// src/components/Pages/PhaseRoadmap.jsx
// Timeline de fases reutilizable (MVP → fases siguientes) con estado.
import React from 'react';

const STATUS = {
  active:   { label: 'Activo',       cls: 'is-active' },
  progress: { label: 'En curso',     cls: 'is-progress' },
  soon:     { label: 'Próximamente', cls: 'is-soon' },
  planned:  { label: 'Planeado',     cls: 'is-planned' },
};

export default function PhaseRoadmap({ phases }) {
  return (
    <div className="ip-roadmap">
      {phases.map((p, i) => {
        const s = STATUS[p.status] || STATUS.planned;
        return (
          <div key={i} className={`ip-phase ${s.cls}`}>
            <div className="ip-phase-rail">
              <span className="ip-phase-node" />
              {i < phases.length - 1 && <span className="ip-phase-line" />}
            </div>
            <div className="ip-phase-body">
              <div className="ip-phase-head">
                <span className="ip-phase-kicker">{p.kicker}</span>
                <span className={`ip-phase-status ${s.cls}`}>{s.label}</span>
              </div>
              <h3 className="ip-phase-title">{p.title}</h3>
              {p.desc && <p className="ip-phase-desc">{p.desc}</p>}
              <ul className="ip-phase-list">
                {p.items.map((it, j) => <li key={j}>{it}</li>)}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
}
